/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_TaxService_Dtos_Dashboard_TaxAdminDashboardResponseDto } from '../models/Wealthlane_TaxService_Dtos_Dashboard_TaxAdminDashboardResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * @returns Wealthlane_TaxService_Dtos_Dashboard_TaxAdminDashboardResponseDto OK
     * @throws ApiError
     */
    public static getApiTaxApiAppDashboardAdminDashboard(): CancelablePromise<Wealthlane_TaxService_Dtos_Dashboard_TaxAdminDashboardResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tax/api/app/dashboard/admin-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
